// Русская буква внутри латинского адреса почты — почти всегда не та раскладка:
// «с», «о», «а», «е», «р» на вид не отличить от латинских. Сервер видит чужой
// домен и отвечает «домен не разрешён», а человек смотрит на верный с виду
// адрес и не понимает, что не так (02.10.2026: девять попыток войти как
// mvgalats@1сbit.ru с русской «с», и экран отвечал «вход для клиентов — на
// клиентском домене»).
//
// Ловим только СМЕШЕНИЕ внутри одной части адреса (до @ или между точками):
// русская буква рядом с латиницей или цифрой («1сbit», «1с»). Целиком
// кириллический домен вроде «почта.рф» — настоящий адрес, его не трогаем.
const CYRILLIC = /[Ѐ-ӿ]/;
const CYRILLIC_ALL = /[Ѐ-ӿ]/g;
const LATIN_OR_DIGIT = /[a-z0-9]/i;

/** Текст ошибки, если в адресе латиница или цифры перемешаны с русскими буквами, иначе ''. */
export function emailLayoutError(email) {
  const parts = (email || '').trim().split(/[@.]/);
  const mixed = parts.filter((p) => CYRILLIC.test(p) && LATIN_OR_DIGIT.test(p));
  if (!mixed.length) return '';
  const letters = [...new Set(mixed.join('').match(CYRILLIC_ALL))].map((c) => `«${c}»`).join(', ');
  return `В адресе есть русские буквы: ${letters}. Переключите раскладку и наберите адрес латиницей.`;
}
